import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';
import FilterSorting from '@/components/Blue/ProductListing/FilterSorting.vue';
import FilterResetAll from '@/components/Blue/ProductListing/FilterResetAll.vue';
import FilterUniversal from '@/components/Blue/ProductListing/FilterUniversal.vue';
import FilterPriceRange from '@/components/Blue/ProductListing/FilterPriceRange.vue';
import FilterDeals from '@/components/Blue/ProductListing/FilterDeals.vue';
import FilterNewlyArrived from '@/components/Blue/ProductListing/FilterNewlyArrived.vue';
import { BlueFilterType } from '@/enums/BlueFilterType';
import OpenPopupButton from '@/components/PopUps/OpenPopupButton.vue';
export default defineComponent({
    name: 'listing-filters',
    components: {
        OpenPopupButton,
        FilterDeals,
        FilterNewlyArrived,
        FilterResetAll,
        FilterSorting,
        FilterUniversal,
        FilterPriceRange,
    },
    data: () => ({}),
    computed: Object.assign({ BlueFilterType() {
            return BlueFilterType;
        } }, mapGetters('blue', {
        availableFilters: 'availableFilters',
        currentPageInfo: 'currentPageInfo',
        currentListingType: 'getListingType',
    })),
});
